import React, { Fragment } from 'react';

import ActionIcon from 'elements/ActionIcons/ActionIcon';
import Tooltip from 'elements/Tooltip/Tooltip';
import { Layout, Row, Title, Label, Description } from 'elements/Tooltip/Layout';


/* eslint-disable react/prop-types */
export const DefaultActionIcon = ({ type = '80', darkBg }) => {
  const iconSizeMap = {
    '15'         : 'information',
    '20'         : 'add',
    '30'         : 'add',
    '40'         : 'add',
    '80'         : 'add',
    'other'      : 'expand-fill-25',
    'social'     : 'youtube',
    'navigation' : 'clear-fill'
  };

  return (
    <Fragment>
      <div style={{ marginRight: '20px' }}>
        <ActionIcon icon={iconSizeMap[type]} type={type} darkBg={darkBg} />
      </div>
      <div>
        <ActionIcon disabled icon={iconSizeMap[type]} type={type} darkBg={darkBg} />
      </div>
    </Fragment>
  );
};

export const WithCircleActionIcon = ({ large = true, icon = 'external-page', type = '15' }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <ActionIcon withCircle large={large} icon={icon} type={type} />
    </div>
    <div>
      <ActionIcon withCircle disabled large={large} icon={icon} type={type} />
    </div>
  </Fragment>
);

export const NavigationActionIcon = ({ exception = true, darkBg, icon = 'menu', type = 'navigation', notifications }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <ActionIcon exception={exception} darkBg={darkBg} icon={icon} type={type} notifications={notifications} />
    </div>
    <div>
      <ActionIcon disabled exception={exception} darkBg={darkBg} icon={icon} type={type} />
    </div>
  </Fragment>
);

export const WithTextActionIcon = ({ large = true, icon = 'back-to-top', type = '20', text = 'Back To Top' }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <ActionIcon large={large} icon={icon} type={type} text={text} />
    </div>
    <div>
      <ActionIcon disabled large={large} icon={icon} type={type} text={text} />
    </div>
  </Fragment>
);

export const WithTooltipActionIcon = ({ icon = 'information', type = '15' }) => (
  <Fragment>
    <div style={{ marginRight: '20px' }}>
      <Tooltip placement="top" target={<ActionIcon icon={icon} type={type} />}>
        <Layout>
          <Row>
            <Title>Title</Title>
          </Row>
          <Row>
            <Description>Description Text Here Two lines</Description>
          </Row>
          <Row spaceBetween>
            <Label inline>label</Label>
            <Label inline>label</Label>
          </Row>
        </Layout>
      </Tooltip>
    </div>
  </Fragment>
);
/* eslint-enable react/prop-types */


// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/constants/actionIconsLayouts.js